import { createContext, useContext, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const StableLocationContext = createContext(null);

const StableLocationProvider = ({ children }) => {
  const location = useLocation();
  const locationRef = useRef(location);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  return (
    <StableLocationContext.Provider value={locationRef}>
      {children}
    </StableLocationContext.Provider>
  );
};

const useStableLocation = () => {
  const locationRef = useContext(StableLocationContext);
  if (!locationRef) {
    throw new Error("useStableLocation must be used within a StableLocationProvider");
  }
  return locationRef.current;
};

export { StableLocationProvider, useStableLocation };
